export default __webpack_public_path__ + "static/media/back.btn.5a3743cd.svg";